export const ABONO_CUENTA = "ABONO_CUENTA";
export const DEVOLUCION_CUENTA = "DEVOLUCION_CUENTA";
export const SET_CUENTA = "SET_CUENTA";
export const NEW_CUENTA = "NEW_CUENTA";
